export default __webpack_public_path__ + "static/media/f-02.92b82eb3.jpg";